import { urlBackend } from '../constants';
import { erpApi } from '../axios';
import { getUrlParamsFetch, handleAxiosError } from '../utils';


interface useDownloadFileParams {
  url: string;
  method: "post" | "get";
  data?: any;
  nameFile?: string;
  extensionFile?: string;
  params?: any;
  customErrorMessage?: string;
}

const { get, post } = erpApi({ customTimeOut: 300000 })

export const useDownloadFile = () => {


  async function handleDownloadFile({
    url,
    method = "get",
    data,
    nameFile = "Reporte",
    extensionFile = "xlsx",
    params,
    customErrorMessage
  }: useDownloadFileParams) {
    const stateParams = { ...params };
    const queryParams = getUrlParamsFetch(stateParams);


    try {
      let resp: any;
      if (method == "get") {
        resp = await get<Blob>(
          `${urlBackend}${url}${queryParams}`,
          true,
          false
        );
      } else {
        resp = await post<Blob>(
          `${urlBackend}${url}`,
          data,
          true,
          false
        );
      }
      if (!(resp instanceof Blob)) {
        console.error('El valor pasado no es un Blob');
        return;
      }

      if (typeof window !== 'undefined') {
        const url = window.URL.createObjectURL(resp);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${nameFile} ${new Date().toLocaleDateString("es-EC")} ${new Date().toLocaleTimeString("es-EC")}.${extensionFile}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
      handleAxiosError(error, customErrorMessage || "Ocurrió un problema al intentar generar el documento. Por favor, contacte a soporte.");
    }

  }

  return {
    handleDownloadFile
  }
}